import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHandTypes, ShowerHeadTypes} from "../../constants";

export default class HandShowerHolder extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'hand_shower_holder';
    this.partName = 'Hand Shower Holder';
    this.translateId = "visualizer.bathroom.shower.hand_shower_holder";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    const showerParent = this.getParent().getParent();
    showerParent.setShowerHandType(ShowerHeadTypes.shower_arm);
    showerParent.setShowerHandType(ShowerHandTypes.hand_shower_holder);
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm || showerParent.shower_hand_type !== ShowerHandTypes.hand_shower_holder
  }

  // getArrayOfConditions() {
  //   const showerParent = this.getParent();
  //   let conditions = super.getArrayOfConditions(); //roomLayout
  //   //Hand Shower Kit should be displayed with the fixtures that have MountType: 0
  //   if (showerParent.wallUnion && showerParent.wallUnion.activeFeature && showerParent.wallUnion.activeFeature.metaData["MountPosition"]) {
  //     conditions.push({
  //       propName: "MountPosition",
  //       propValue: showerParent.showerFixture.activeFeature.metaData["MountPosition"]
  //     })
  //   }
  //   return conditions
  // }

}
